import React from 'react'
import { Link } from 'react-router-dom'

import ArrowLeft from './../static/images/arrow_left_bold_stroke.svg'
import Logo from './../static/images/logo_2_lines.svg'

const getSubtitle = (location, polyglot, type, validPaths) => {
  location = location.pathname.split('/')[1]
  if ((validPaths[type] || []).includes(location)) {
    return polyglot.t('subtitle.' + location)
  }
  return ''
}

class Header extends React.PureComponent {
  render = () => (
    <header>
      <Link
        to='/'
        onClick={() => {
          this.props.handleError(false)
        }}
        title={this.props.polyglot.t('logoTitle')}
      >
        <img id='logo' src={Logo} />
      </Link>
      {this.props.type !== '' && (
        <div className='section_title'>
          {getSubtitle(
            this.props.location,
            this.props.polyglot,
            this.props.type,
            this.props.validPaths
          )}
        </div>
      )}
      {this.props.warning !== '' && (
        <div id='error_message'>{this.props.warning}</div>
      )}
      {this.props.type !== '' && (
        <div id='logout'>
          {this.props.firstname} {this.props.lastname}
          <span className='tab' />
          <form
            action={this.props.url.logout}
            method='post'
            style={{ display: 'inline-block' }}
          >
            <button id='logout_button'>
              <img src={ArrowLeft} className='arrow_left' />{' '}
              {this.props.polyglot.t('logout')}
            </button>
          </form>
        </div>
      )}
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/header.js